const EdugramIconNew = dynamic(
  () =>
    import('@public/static/icons/edugramIcon').then(
      (mod) => mod.EdugramIconNew
    ),
  { ssr: false, loading: () => <div className="min-w-[236px]" /> }
)
import { useAuth } from '@contexts/Auth'
// import {
//   HeaderContainer,
//   InternalWrapper,
//   Logo,
//   AuthorWrapper,
//   SearchContainer,
// } from './styled.components'
import { Skeleton } from '@nextui-org/react-latest'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import { Divider } from '@styled_components/checkout/styled.components'
import { Button as NButton } from '@nextui-org/react-latest'
import SearchSection from '@components/molecules/SearchSection'

// Icons
// import CartIcon from '@public/static/icons/headerIcons/cart-icon'
// import WishlistIcon from '@public/static/icons/headerIcons/wishlist-icon'
// import MyCoursesIcon from '@public/static/icons/headerIcons/my-courses-icon'
// import UkraineIcon from '@public/static/icons/languageIcons/ukraine-icon'
// import EnglishIcon from '@public/static/icons/languageIcons/english-icon'
// import NotificationIcon from '@public/static/icons/headerIcons/notification-icon'

// const CartIcon = dynamic(
//   () => import('@public/static/icons/headerIcons/cart-icon')
// )
// const WishlistIcon = dynamic(
//   () => import('@public/static/icons/headerIcons/wishlist-icon')
// )
// const MyCoursesIcon = dynamic(
//   () => import('@public/static/icons/headerIcons/my-courses-icon')
// )
// const NotificationIcon = dynamic(
//   () => import('@public/static/icons/headerIcons/notification-icon')
// )
// const UkraineIcon = dynamic(
//   () => import('@public/static/icons/languageIcons/ukraine-icon')
// )
// const EnglishIcon = dynamic(
//   () => import('@public/static/icons/languageIcons/english-icon')
// )

import useWindowDimensions from '@hooks/useWindowDimensions'

const renderRightLoader = () => {
  return (
    <>
      <div className="md:!flex hidden mr-[19px] ml-auto gap-4">
        <Skeleton className="w-[30px] h-[30px] rounded-full lg:block hidden" />
        <Skeleton className="w-[30px] h-[30px] rounded-full lg:block hidden" />
        <Skeleton className="w-[30px] h-[30px] rounded-full lg:block hidden" />
      </div>
      <Skeleton className="w-[2.75rem] h-[2.75rem] rounded-full lg:block hidden" />
    </>
  )
}

const HamburgerMenu = dynamic(() => import('./HamburgerMenu'), { ssr: false })
import dynamic from 'next/dynamic'
import styled from '@emotion/styled'
import Link from 'next/link'
// import Icon from '@public/static/Icon'
// import CartIcon from '@public/static/icons/headerIcons/cart-icon'
const HeaderRight = dynamic(() => import('./HeaderRight'), {
  ssr: false,
  loading: renderRightLoader,
})

interface HeaderProps {
  displayHelpCentreTitle?: boolean
  onLogoClick?: () => void
  hideHeader?: boolean
  hideLogoOnMobile?: boolean
  hideSearch?: boolean
  hasSideBar?: boolean
  onExpand?: () => void
}

const Header = ({
  displayHelpCentreTitle = false,
  onLogoClick,
  hideHeader,
  hideLogoOnMobile = false,
  hideSearch = false,
  hasSideBar = false,
  ...props
}: HeaderProps) => {
  const router = useRouter()
  const { t } = useTranslation(['common'])
  const { user, isAuthLoading } = useAuth()
  const { width } = useWindowDimensions()

  return (
    <>
      <HeaderContainer
        hideHeader={hideHeader}
        courseSection={[
          'create-course',
          'author',
          'student',
          'referrals',
        ].includes(router.asPath.split('/')[1])}
        hideLogoOnMobile={hideLogoOnMobile}
      >
        <InternalWrapper>
          <div
            onClick={() => {
              if (onLogoClick) {
                onLogoClick()
              }
            }}
            className={`${
              hideLogoOnMobile ? 'hidden scale-0' : 'inline scale-100'
            } sm:inline sm:scale-100`}
          >
            <Logo
              as={Link}
              href={'/courses'}
              isScrollingUp={true}
              className="relative"
            >
              <EdugramIconNew displayAsHelpCenter={displayHelpCentreTitle} />

              {/* <svg
                width="45"
                height="29"
                viewBox="0 0 81 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="absolute top-[7px] -right-[18.5px]"
              >
                <path
                  d="M7.17955 39.8468C7.17955 39.8468 31.7493 3.61783 46.9383 7.5865C53.977 9.42572 55.9076 19.7319 65.7574 46.8497C67.9101 52.7762 55.6547 44.9543 52.6687 41.5946C52.6687 41.5946 54.0759 55.368 52.0482 56.8808C48.2608 59.7063 3.94321 45.6105 7.17955 39.8468Z"
                  fill="black"
                />
                <path
                  d="M8.99579 39.1779C8.99579 39.1779 32.5825 5.12142 46.2824 8.77226C53.3128 10.6457 53.4189 18.534 64.6825 46.2285C67.0322 52.0059 54.3254 42.2654 51.3392 38.9058C51.3392 38.9058 52.8973 54.3601 50.8696 55.8729C47.0822 58.6984 5.75934 44.9414 8.99579 39.1779Z"
                  fill="#FF0000"
                />
                <path
                  d="M53.7915 41.2652C51.1342 37.9875 50.4819 35.2745 48.3242 27.4199C48.3242 27.4199 51.3636 40.3154 51.6968 43.3615C52.0302 46.4076 51.763 40.5334 52.341 40.6509C52.9191 40.7685 54.0625 41.5992 53.7915 41.2652Z"
                  fill="black"
                />
                <path
                  d="M48.3242 27.4199C48.3242 27.4199 57.5027 44.9059 62.2315 45.9481C62.2315 45.9481 61.6564 46.6025 61.5228 46.8758C61.4215 47.083 55.198 44.9972 51.9435 38.8784C50.5968 36.3466 49.0957 30.2303 48.3242 27.4199Z"
                  fill="#BA0808"
                />
                <path
                  d="M46.0039 28.0703C46.0039 28.0703 48.8569 31.097 51.1912 40.5633C52.036 43.9891 50.489 31.8113 46.0039 28.0703Z"
                  fill="black"
                />
                <path
                  d="M52.722 61.4831C52.9482 60.2504 53.1966 59.3554 51.4754 56.1459C49.4427 53.6867 47.7358 52.5428 46.3118 51.9014C45.8507 51.6935 48.9122 52.0279 48.5504 51.7426C42.7203 47.1415 36.2202 46.0424 36.2202 46.0424L38.9968 44.7774C35.4983 42.3189 27.3116 40.3937 23.5415 40.1254L26.5499 39.1716C21.4395 37.4307 14.9783 36.8027 11.4121 37.9703C11.0552 38.0873 11.8272 36.8816 11.8272 36.8816L9.37421 37.1138C6.59705 37.6354 5.18442 38.7612 4.24389 42.214L2.87543 47.7363C2.38958 49.4283 3.67404 51.2446 5.97967 51.1571C5.97967 51.1571 11.5018 51.1077 26.8059 56.8228C41.2634 62.2218 45.3703 68.4677 45.3703 68.4677C47.4729 70.5863 49.309 69.2714 50.9445 66.3073L52.722 61.4831Z"
                  fill="black"
                />
                <path
                  d="M47.162 68.3571C46.7953 68.2579 46.4085 68.011 46.0119 67.6222C45.7038 67.1838 44.8561 65.673 41.2563 63.1109C41.0028 62.9305 42.2243 63.1632 42.2243 63.1632C40.0089 62.0987 35.4484 59.3654 32.3836 57.943C31.6532 57.6043 34.4474 57.9429 33.6445 57.6051C32.7157 57.2142 28.177 56.1475 27.1468 55.7628C23.0207 54.222 16.2803 52.8309 14.1586 50.3573C13.8808 50.0331 15.1248 51.7994 14.7596 51.7006C11.5255 50.8258 9.31955 50.359 7.92935 50.2247C6.59989 50.0964 6.18764 49.1676 6.21877 49.3536C6.35688 50.176 6.13326 50.0565 6.09195 50.057L6.07296 50.0574C5.74447 50.0698 5.43222 50.0368 5.14502 49.9591C4.47637 49.7782 3.95165 49.3478 3.74155 48.8077C3.63866 48.5432 3.62276 48.2827 3.69454 48.0328L3.70877 47.9797L5.07289 42.4742C5.82929 39.7025 7.3496 38.2995 10.5527 37.9641L9.71695 39.1531C13.3445 38.1959 15.5894 36.948 23.3329 39.0363C23.1643 39.2203 21.0863 40.6213 21.0863 40.6213C21.0863 40.6213 27.9448 41.2531 36.9464 44.9673C36.8576 45.1312 35.0952 46.1339 35.0952 46.1339C35.0952 46.1339 38.6709 47.3722 39.1595 47.5044C41.594 48.1629 44.3971 49.7941 46.1902 51.1412C45.3703 51.0648 44.8808 51.5036 44.8501 51.5588C44.8501 51.5588 45.7827 52.1138 46.2616 52.4277C47.9423 53.5292 52.9281 57.3738 51.9359 61.2282L50.2399 65.8321C48.6117 68.7372 47.5287 68.4563 47.1661 68.3582C47.1646 68.3578 47.1632 68.3575 47.162 68.3571Z"
                  fill="white"
                />
                <path
                  d="M49.3766 67.1164C48.2235 68.6051 47.4525 68.4059 47.1578 68.3262L47.1529 68.3249C46.7865 68.2258 46.4007 67.9772 46.0036 67.5882C45.6958 67.1515 44.8474 65.6405 41.2479 63.0781C40.9948 62.8978 42.2171 63.1308 42.2171 63.1308C40 62.0658 35.4409 59.3322 32.375 57.9098C31.645 57.5704 34.4393 57.9096 33.6361 57.5715C32.7068 57.1805 28.1694 56.1138 27.1394 55.7305C23.013 54.1886 16.2725 52.7981 14.1505 50.3237C13.873 49.9997 15.116 51.7667 14.7512 51.668C11.517 50.7932 9.31192 50.327 7.9218 50.1928C6.59135 50.0633 6.18001 49.1356 6.2101 49.3206C6.34861 50.1419 6.12571 50.0235 6.08399 50.0239L6.06444 50.0255C5.73571 50.0365 5.42444 50.0036 5.13792 49.9261C4.4686 49.745 3.94423 49.3149 3.73453 48.7743C3.62981 48.5108 3.61485 48.2488 3.68682 48.0005L3.70158 47.9464L5.06431 42.4413C5.58758 40.5287 6.4718 39.2698 8.02187 38.5607C7.49555 38.9491 6.20595 39.8022 5.85945 41.8407L4.8383 46.3043C4.73834 47.0042 4.89975 47.4811 5.02784 47.7223C5.41575 48.4523 6.14258 48.4925 6.81189 48.6736C7.09842 48.7511 7.41129 48.7845 7.73841 48.7731L7.75796 48.7714C7.79968 48.771 8.02258 48.8894 7.88569 48.0685C7.85398 47.8831 8.26694 48.8113 9.59591 48.9404C10.9859 49.0745 13.191 49.5409 16.4253 50.4157C16.7917 50.5148 15.5471 48.7474 15.8246 49.0714C17.9466 51.5459 24.687 52.9363 28.8134 54.4782C29.8433 54.8615 34.67 56.6665 35.5993 57.0574C36.4009 57.3951 33.7912 57.4733 34.521 57.8126C37.5868 59.2351 41.9318 61.2225 44.1471 62.287C44.1471 62.287 42.7914 62.2738 43.0444 62.4541C46.6456 65.0169 47.3698 65.8993 47.6791 66.3364C48.0746 66.7249 48.4605 66.9735 48.8285 67.0731C48.8285 67.0731 48.8303 67.0735 48.8318 67.0739C48.9441 67.1041 49.128 67.1539 49.3766 67.1164Z"
                  fill="#E5E5E5"
                />
                <path
                  d="M60.6993 57.1686C60.1092 56.2835 56.5003 52.3436 59.3515 46.383C60.1869 44.637 62.077 42.6012 63.2348 41.7442C63.3718 41.6428 62.0087 44.226 62.8015 43.663C65.377 41.8343 69.0887 40.5087 71.1226 41.7372C71.2953 41.8413 69.254 42.8041 69.4206 42.9308C69.6523 43.1073 72.6938 45.2308 73.2332 49.2776C73.2332 49.2776 72.6219 48.3738 72.0267 49.1519C71.6726 49.615 72.5129 51.4487 71.0413 55.4689C70.3284 57.4167 68.2588 60.3119 66.7117 60.3282C66.7117 60.3282 67.1765 58.6115 66.8336 58.7222C62.8514 60.0075 59.5189 58.7441 59.3429 58.0587C59.3245 57.9869 61.0262 57.6596 60.6993 57.1686Z"
                  fill="black"
                />
                <path
                  d="M61.0718 57.9329C61.229 57.9666 61.6637 57.7615 61.4911 57.3098C61.2732 56.7389 57.1106 53.1292 60.0957 46.8704C60.511 45.9994 61.7857 44.168 61.6562 44.5586C61.5165 44.9803 61.3456 46.3 62.0809 45.4922C63.8062 43.5964 67.2247 41.8422 69.0832 42.2902C69.0746 42.3544 68.348 42.69 68.4541 43.1711C68.5289 43.5115 71.3289 44.5884 72.6776 48.3357C72.1271 47.7263 71.4951 48.3025 71.4565 48.5748C71.2438 50.0762 71.717 51.6067 70.6352 54.605C70.0586 56.2028 68.7661 58.3761 67.9069 58.8282C67.8241 58.5485 68.1986 57.5727 67.7534 56.7403C67.6626 56.5707 67.6805 57.0899 66.8872 57.6223C63.951 59.5928 61.1575 58.0859 61.0718 57.9329Z"
                  fill="white"
                />
                <path
                  d="M71.1429 52.9685C71.0288 53.4982 70.8629 54.0855 70.6222 54.7418C70.0363 56.3334 68.733 58.4982 67.8724 58.9417C67.7917 58.6604 67.9919 57.482 67.8515 56.9049C67.832 56.8245 67.6565 57.1999 66.86 57.7236C63.915 59.6689 61.1325 58.1349 61.0478 57.9813C61.2043 58.0147 61.6405 57.8137 61.4699 57.3613C61.2669 56.817 57.5443 53.5128 59.7141 47.8699C58.8064 52.4585 61.7942 55.1439 61.9748 55.6305C62.1455 56.0829 61.7104 56.2841 61.5524 56.2501C61.6375 56.4043 64.4213 57.9382 67.3662 55.993C68.1612 55.4689 68.1429 54.9514 68.2359 55.1191C68.4982 55.5932 68.4503 56.9213 68.3775 57.211C69.2383 56.7671 70.5429 54.6028 71.1274 53.0107C71.1319 52.9961 71.1384 52.9814 71.1429 52.9685Z"
                  fill="#E5E5E5"
                />
              </svg> */}
            </Logo>
          </div>
          <div
            style={{
              display:
                router.asPath.split('/')[1] != 'author' ? 'flex' : 'none',
              alignItems: 'center',
              flex: 1,
              width: '100%',
              maxWidth: '860px',
              marginRight: 'auto',
            }}
          >
            {router.asPath.split('/')[1] != 'create-course' && !hideSearch ? (
              <SearchContainer className="w-full md:flex-1 lg:max-w-[70%]">
                <SearchSection />
              </SearchContainer>
            ) : (
              <div
                style={{
                  width: '70%',
                }}
              ></div>
            )}
            {isAuthLoading ? (
              <Skeleton className="w-44 h-[50px] ml-[2rem] rounded-[10px] xl:block hidden" />
            ) : (
              <AuthorWrapper>
                <NButton
                  className="h-[50px] font-semiBold tracking-[0rem] text-[15px]"
                  color="primary"
                  style={{ padding: '12px' }}
                  onPress={() =>
                    router.push(
                      user?.isAuthor ? '/author/' : '/author/become-author/'
                    )
                  }
                  data-cy-id="become-author-btn"
                >
                  {user?.isAuthor
                    ? t('header.authorsDashboard', { ns: 'common' })
                    : t('header.becomeAuthor', { ns: 'common' })}
                </NButton>
              </AuthorWrapper>
            )}
          </div>
          {(width || 640) < 640 ? (
            <HamburgerMenu hasSideBar={hasSideBar} onExpand={props?.onExpand} />
          ) : (
            <></>
          )}
          {isAuthLoading ? renderRightLoader() : <HeaderRight />}
        </InternalWrapper>
      </HeaderContainer>
      {displayHelpCentreTitle && width && width > 650 && <Divider />}
    </>
  )
}
export default Header

const HeaderContainer = styled.div`
  // padding: ${(props) => props.courseSection && '0 5%'};
  margin: ${(props) => props.courseSection && '0 auto'};
  max-width: ${(props) => props.courseSection && '1440px'};
  height: 89px;
  width: 100%;
  /* background-color: white; */
  z-index: 9;
  display: flex;
  -ms-display: flex;

  justify-content: center;
  /* padding: 0.5rem calc(2.5vw - 41px); */
  /* Medium devices (landscape tablets, 768px and up) */
  padding: ${(props) => (props.courseSection ? '0 0rem 0 0' : '0 0.9rem')};

  @media (min-width: 640px) {
    /* padding: ${(props) => (props.courseSection ? '0 0.5rem 0  0' : '0')}; */
    padding: 0;
  }
  @media (max-width: 640px) {
    height: ${(props) => props.hideLogoOnMobile && '0px'};
  }
  @media (max-width: 1050px) {
    /* padding: 0 2.5vw; */
    z-index: 9;
    transition: height 0.2s linear;
    /* background-color: white; */
    display: ${(props) => (props.hideHeader ? 'none' : 'flex')};
  }
  position: relative;
  // @media (min-width: 1300px) {
  //   padding: ${(props) => props.courseSection && '0 5% 0  0'};
  // }
`
const SearchContainer = styled.div`
  display: none;
  @media (min-width: 640px) {
    display: flex;
  }
`

const InternalWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  @media (min-width: 640px) {
    align-items: center;
    flex-direction: row;
    width: 100%;
    max-width: 1481px;
    justify-content: space-between;
    display: flex;
  }
`
const Logo = styled.div`
  display: flex;
  min-width: 2rem;
  height: 100%;
  flex-shrink: 1;
  justify-content: flex-start;
  -ms-display: flex;
  cursor: pointer;
  max-width: max-content;
  @media (max-width: 640px) {
    transform: translateY(
      ${(props) => (props.isScrollingUp ? '0px' : '-300px')}
    );
    height: ${(props) => (props.isScrollingUp ? '100%' : '0px')};
    transition:
      transform 0.2s linear,
      height 0.05s linear;
  }
`
const AuthorWrapper = styled.div`
  display: none;
  @media (min-width: 1024px) {
    display: flex;
    margin-left: 2rem;
  }
`
